// extracted by mini-css-extract-plugin
module.exports = {"loading":"Loading_loading__I5Aqj","loading_body":"Loading_loading_body__Ln5li"};